import React from "react";

export default function Outside() {
  return (
    <div className="tw-flex tw-min-h-screen tw-flex-col">
      {/* Header */}
      <header className="tw-sticky tw-top-0 tw-z-50 tw-w-full tw-border-b tw-bg-white">
        <div className="tw-container tw-mx-auto tw-flex tw-h-16 tw-items-center tw-justify-between tw-px-4">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-rs6oyPtizX62BTbLI3CHTJY5Q4CjTm.png"
            alt="Outside Logo"
            className="tw-h-8 tw-w-auto"
          />
          <nav className="tw-hidden tw-gap-6 md:tw-flex">
            <a href="#about" className="tw-text-sm tw-font-medium hover:tw-underline">
              About
            </a>
            <a href="#expeditions" className="tw-text-sm tw-font-medium hover:tw-underline">
              Expeditions
            </a>
            <a href="#contact" className="tw-text-sm tw-font-medium hover:tw-underline">
              Contact
            </a>
          </nav>
          <button className="tw-rounded tw-bg-orange-500 tw-px-4 tw-py-2 tw-text-white hover:tw-bg-orange-600">
            Book Now
          </button>
        </div>
      </header>

      {/* Hero */}
      <section className="tw-relative tw-h-[80vh] tw-overflow-hidden">
        <div className="tw-absolute tw-inset-0 tw-z-10 tw-bg-gradient-to-r tw-from-black/70 tw-to-black/40" />
        <img
          src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2670&auto=format&fit=crop"
          alt="Mountain expedition"
          className="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
        />
        <div className="tw-container tw-relative tw-z-20 tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-center tw-px-4 tw-pl-8 tw-text-white md:tw-pl-12 lg:tw-pl-16">
          <h1 className="tw-mb-4 tw-text-4xl tw-font-bold md:tw-text-6xl">
            Outside Expedition Series
          </h1>
          <p className="tw-mb-8 tw-text-xl md:tw-text-2xl">
            4 Seasons. 4 Off-the-beaten path adventures.
          </p>
          <button className="tw-rounded tw-bg-orange-500 tw-px-6 tw-py-3 tw-text-white hover:tw-bg-orange-600">
            Explore Trips
          </button>
        </div>
      </section>

      {/* About */}
      <section id="about" className="tw-bg-white tw-py-16">
        <div className="tw-container tw-mx-auto tw-px-4">
          <div className="tw-grid tw-grid-cols-1 tw-items-center tw-gap-12 md:tw-grid-cols-2">
            <div>
              <h2 className="tw-mb-6 tw-text-3xl tw-font-bold">About Outside Store</h2>
              <p className="tw-mb-6 tw-text-lg">
                Outside store is an outdoor-lifestyle shop for nature lovers who do not conform to
                the norms. We carry brands such as Fjallraven, Keen, Chums and United by Blue in
                Singapore.
              </p>
              <button
                className="tw-rounded tw-border tw-border-orange-500 tw-bg-orange-50 tw-px-4 tw-py-2 tw-text-orange-500"
                onClick={() => window.open("https://outsidestore.co/", "_blank")}
              >
                Visit Our Store
              </button>
            </div>
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-BQJtiei79i08gj3khNAW9wecyoBh0u.png"
                alt="Store 1"
                className="tw-h-full tw-w-full tw-rounded-lg tw-object-cover"
              />
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-RbIlloFVD2xYjMeZZw3A1AU8x1xcE3.png"
                alt="Store 2"
                className="tw-h-full tw-w-full tw-rounded-lg tw-object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Expeditions */}
      <section id="expeditions" className="tw-bg-white tw-py-16">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-mb-12 tw-text-center tw-text-3xl tw-font-bold">Our Expeditions</h2>
          <div className="tw-grid tw-grid-cols-1 tw-gap-8 md:tw-grid-cols-2">
            {[
              {
                title: "The Secret Trail of Mount Bromo",
                location: "Indonesia",
                tag: "Active Volcano",
                description:
                  "Instead of the typical sunrise jeep tour, you hike and camp on the rim of the active crater itself. You're surrounded by steaming vents, otherworldly volcanic ash fields, and a raw, rugged landscape.",
                highlight:
                  "Watch the sunrise not from the crowded viewpoint, but from your private crater-side tent, with lava rumblings under your feet.",
                img: "https://images.unsplash.com/photo-1589553416260-f586c8f1514f?q=80&w=2574&auto=format&fit=crop",
              },
              {
                title: "Hike the 'Headhunter's Trail' in Mulu National Park",
                location: "Malaysia, Borneo",
                tag: "Tribal Route",
                description:
                  "This trail follows an old tribal route once used by the headhunting Kayan warriors. You start deep in limestone cave systems and end with a longboat journey through remote rivers.",
                highlight:
                  "Explore the world's largest cave chamber (Sarawak Chamber) and trek through dense, untouched jungle.",
                img: "https://media.worldnomads.com/stories-images/headhunter/borneo-summit.jpg",
              },
              {
                title: "Snow Lake Trek, Karakoram",
                location: "Pakistan",
                tag: "Glacial Basin",
                description:
                  "This is one of the most remote glacial basins on earth, hidden in the Karakoram range. The name 'Snow Lake' is deceptive — it's an expansive glacier surrounded by 6,000m+ peaks.",
                highlight:
                  "Feel like a dot in the Himalayas, camping on a glacier with only snow leopards and wild ibex as company.",
                img: "https://images.unsplash.com/photo-1621682372775-533449e550ed?q=80&w=2574&auto=format&fit=crop",
              },
              {
                title: "Yushan (Jade Mountain) via Paiyun Lodge",
                location: "Taiwan",
                tag: "Highest Peak in East Asia",
                description:
                  "Yushan is the highest peak in East Asia, and the hike combines alpine forests, sunrises above the clouds, and cherry blossoms in season. The trek via Paiyun Lodge offers a well-maintained yet challenging multi-day experience.",
                highlight:
                  "Summit before dawn to witness the sea of clouds — a surreal sunrise moment Taiwan hikers treasure.",
                img: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?q=80&w=2670&auto=format&fit=crop",
              },
            ].map((trip, i) => (
              <div
                key={i}
                className="tw-overflow-hidden tw-rounded-lg tw-border tw-bg-white tw-shadow-sm"
              >
                <div className="tw-relative tw-h-64">
                  <img
                    src={trip.img}
                    alt={trip.title}
                    className="tw-h-full tw-w-full tw-object-cover"
                  />
                  <div className="tw-absolute tw-bottom-0 tw-left-0 tw-bg-orange-500 tw-px-4 tw-py-2 tw-text-white">
                    {trip.location}
                  </div>
                </div>
                <div className="tw-p-6">
                  <h3 className="tw-mb-2 tw-text-xl tw-font-bold">{trip.title}</h3>
                  <div className="tw-mb-2 tw-text-sm tw-text-orange-500">{trip.tag}</div>
                  <p className="tw-mb-2 tw-text-gray-700">{trip.description}</p>
                  <p className="tw-font-semibold">Highlight: {trip.highlight}</p>
                  <div className="tw-mt-6 tw-flex tw-items-center tw-justify-between">
                    <button className="tw-rounded tw-border tw-border-gray-300 tw-px-4 tw-py-2 tw-text-gray-800 hover:tw-bg-gray-100">
                      Learn More
                    </button>
                    <button className="tw-rounded tw-bg-orange-500 tw-px-4 tw-py-2 tw-text-white hover:tw-bg-orange-600">
                      Book Trip
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="tw-bg-gray-900 tw-py-12 tw-text-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <div className="tw-grid tw-grid-cols-1 tw-gap-8 md:tw-grid-cols-4">
            <div>
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-rs6oyPtizX62BTbLI3CHTJY5Q4CjTm.png"
                alt="Logo"
                className="tw-mb-4 tw-h-8 tw-w-auto tw-brightness-0 tw-invert"
              />
              <p className="tw-mt-4 tw-text-gray-400">
                For nature lovers who do not conform to the norms.
              </p>
            </div>
            <div>
              <h3 className="tw-mb-4 tw-text-lg tw-font-semibold">Expeditions</h3>
              <ul className="tw-space-y-2">
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Mount Bromo
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Headhunter's Trail
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Snow Lake Trek
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Yushan
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="tw-mb-4 tw-text-lg tw-font-semibold">About Us</h3>
              <ul className="tw-space-y-2">
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Our Story
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Team
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="tw-text-gray-400 hover:tw-text-white">
                    Press
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="tw-mb-4 tw-text-lg tw-font-semibold">Contact</h3>
              <address className="tw-not-italic tw-text-gray-400">
                <p>123 Adventure Way</p>
                <p>Singapore 123456</p>
                <p className="tw-mt-4">info@outsidestore.com</p>
                <p>+65 1234 5678</p>
              </address>
            </div>
          </div>
          <div className="tw-mt-12 tw-border-t tw-border-gray-800 tw-pt-8 tw-text-center tw-text-gray-400">
            <p>© {new Date().getFullYear()} Outside Store. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
